<template>
  <section class="transparency">
    <div class="container">
      <div class="transparency-card reveal">
        <div class="card-inner">
          <div class="tag">The Roadmap</div>
          <h2>We're Building This <span>With You</span></h2>

          <div class="content-split">
            <div class="text-block reveal delay-1">
              <p class="lead-text">
                Bizzento already masters your
                <strong>daily operations</strong>—customer support, scheduling,
                and seamless communications.
              </p>
              <p>
                Now, we’re crafting the
                <strong>business intelligence engine</strong>. We aren't
                building this in a vacuum; we’re building it for the
                entrepreneurs who live it every day.
              </p>

              <div class="beta-callout">
                <div class="icon-frame-small">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"
                    />
                    <path
                      d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"
                    />
                    <path d="M9 12H4s.55-3.03 2-5c1.62-2.2 5-3 5-3" />
                    <path d="M12 15v5s3.03-.55 5-2c2.2-1.62 3-5 3-5" />
                  </svg>
                </div>
                <p>
                  <strong>Launching Q1 2026</strong> — We're looking for 10
                  visionary entrepreneurs to join our closed beta program.
                </p>
              </div>
            </div>

            <div class="perks-block reveal delay-2">
              <h3>Founder Perks</h3>
              <ul class="benefits-list">
                <li>
                  <div class="check-frame">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  Get early access to our Intelligence Suite
                </li>
                <li>
                  <div class="check-frame">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  Shape the insights that drive your industry
                </li>
                <li>
                  <div class="check-frame">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  Lock in permanent "Founding Member" pricing
                </li>
              </ul>

              <a href="#waitlist" class="cta-button">Join the Beta Program</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.transparency {
  --bg-warm-base: #f2eee0;
  --sunlight-glow: #faefca;
  --soft-gold: #f5e5b0;
  --dark-accent: #1a1a1a;
  --text-muted: #8e8a82;
  --gold-highlight: #bfa14d;

  padding: 100px 24px;
  background-color: var(--bg-warm-base);
  color: var(--dark-accent);
}

.container {
  max-width: 1000px;
  margin: 0 auto;
}

.transparency-card {
  background: white;
  border-radius: 48px;
  padding: 12px;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.05);
  position: relative;
}

.card-inner {
  padding: 60px;
  border-radius: 40px;
  border: 1px solid var(--soft-gold);
  background-image: radial-gradient(
    at 0% 0%,
    var(--sunlight-glow) 0%,
    transparent 40%
  );
}

.tag {
  display: inline-block;
  font-weight: 800;
  font-size: 0.75rem;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--gold-highlight);
  margin-bottom: 16px;
}

h2 {
  font-size: clamp(2rem, 4vw, 2.5rem);
  margin-bottom: 40px;
  line-height: 1.2;
  font-weight: 800;
}

h2 span {
  color: var(--gold-highlight);
}

.content-split {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 60px;
  text-align: left;
}

.lead-text {
  font-size: 1.25rem;
  margin-bottom: 20px;
  line-height: 1.6;
  color: var(--dark-accent);
}

.text-block p {
  color: var(--text-muted);
  line-height: 1.7;
}

/* Beta Callout Fix */
.beta-callout {
  margin-top: 40px;
  display: flex;
  gap: 16px;
  align-items: center;
  background: var(--sunlight-glow);
  padding: 20px;
  border-radius: 20px;
  border: 1px dashed var(--gold-highlight);
}

.icon-frame-small {
  width: 40px;
  height: 40px;
  background: white;
  color: var(--gold-highlight);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  flex-shrink: 0;
}

/* Perks List Fix */
.perks-block h3 {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 24px;
}

.benefits-list {
  list-style: none !important;
  padding: 0;
  margin: 0 0 40px 0;
}

.benefits-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
  font-weight: 600;
  font-size: 1rem;
  color: var(--dark-accent);
  list-style-type: none;
}

.check-frame {
  width: 24px;
  height: 24px;
  background: var(--sunlight-glow);
  color: var(--gold-highlight);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  flex-shrink: 0;
}

/* CTA Button Fix */
.cta-button {
  display: block;
  text-align: center;
  background: var(--dark-accent);
  color: white;
  padding: 20px;
  border-radius: 100px; /* Pill shape */
  text-decoration: none;
  font-weight: 700;
  transition: all 0.3s ease;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

@media (max-width: 850px) {
  .content-split {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  .card-inner {
    padding: 40px 24px;
  }
  .cta-button {
    width: 100%;
  }
}
</style>
